import { useViewportLayout } from './ViewportProvider'
import { isLightweightViewer, readViewportCapabilities, yieldToMainThread } from './readCapabilities'

export { isLightweightViewer, yieldToMainThread }

/** iOS fallback: 1× buffer. Android uses `getLightweightPixelRatio()`. */
export const LIGHTWEIGHT_DPR = 1

const ANDROID_PHONE_DPR_CAP = 2
const ANDROID_TABLET_DPR_CAP = 2

export function isIosWebKit(): boolean {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent
  if (/iP(hone|od|ad)/.test(ua)) return true
  return /Mac/.test(ua) && navigator.maxTouchPoints > 1
}

/**
 * Android (and other non-iOS phones) can take MSAA. iOS Safari OOM'd when we
 * combined antialias + a large drawing buffer.
 */
export function shouldUseLightweightAntialias(): boolean {
  return !isIosWebKit()
}

/** Native-ish DPR on Android; stay at 1× on iOS. */
export function getLightweightPixelRatio(): number {
  if (typeof window === 'undefined') return LIGHTWEIGHT_DPR
  if (isIosWebKit()) return LIGHTWEIGHT_DPR
  const { isCompactTablet } = readViewportCapabilities()
  const cap = isCompactTablet ? ANDROID_TABLET_DPR_CAP : ANDROID_PHONE_DPR_CAP
  const native = window.devicePixelRatio || 1
  return Math.min(Math.max(native, 1), cap)
}

export function useLightweightViewer(): boolean {
  const { layoutMode, pointerMode } = useViewportLayout()
  return layoutMode === 'compact' && pointerMode === 'coarse'
}
